import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppFooter as SharedAppFooter } from "@scryerlabs/ui";
import {
  environment,
  environmentColors,
  isProduction,
} from "../../config/environment";
import { routePaths } from "../../routes/route-paths";

const footerLinkClass = "text-body-secondary text-decoration-none small";

export function AppFooter() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <SharedAppFooter
      start={
        <div className="d-flex align-items-center flex-wrap gap-3 app-footer-links">
          <span>
            &copy; {currentYear} {t("common:app.footer")}
          </span>
          <div className="vr d-none d-bo-block" />
          {/* Grouped rather than loose in the row above so a phone can lay the links out on
              their own, clear of the copyright — see .app-footer-link-group in custom.scss.

              Ordered as somewhere to get help, then someone to ask, then the three
              published legal documents, then the third-party notices. The legal three
              stay adjacent and in the order they reference each other. */}
          <div className="app-footer-link-group">
            <Link to={routePaths.help} className={footerLinkClass}>
              {t("footer.help")}
            </Link>
            <Link to={routePaths.contact} className={footerLinkClass}>
              {t("footer.contact")}
            </Link>
            <Link to={routePaths.terms} className={footerLinkClass}>
              {t("footer.terms")}
            </Link>
            <Link to={routePaths.privacy} className={footerLinkClass}>
              {t("footer.privacy")}
            </Link>
            <Link to={routePaths.disclosures} className={footerLinkClass}>
              {t("footer.disclosures")}
            </Link>
            <Link to={routePaths.notices} className={footerLinkClass}>
              {t("footer.notices")}
            </Link>
          </div>
        </div>
      }
      // No fallback, deliberately. This is fed by the pipeline and a local build has no
      // build number to show; the string that used to stand in here shipped to production
      // unchanged for every release, so prod read as a dev build and the number named nothing.
      version={import.meta.env.VITE_APP_VERSION || undefined}
      // No ribbon in production, deliberately. This is a customer-facing portal: the
      // ribbon exists to caution people who can break something, and a red PROD badge in
      // a product someone pays for reads as an internal tool leaking out. Absence of a
      // ribbon IS the signal for prod. The back office keeps its ribbon everywhere.
      environmentLabel={isProduction ? undefined : environment}
      environmentColor={environmentColors[environment]}
    />
  );
}
